import React from 'react';
import c from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import WidgetBox, { Props as WidgetBoxProps } from '../_partials/WidgetBox';
import PrivateStatus from './_partials/PrivateStatus';
import AdoptabobblesBought from './AdoptabobblesBought';

import s from './AdoptabobblesBoughtBox.scss';

interface Props extends WidgetBoxProps {
  deviations?: PapiDeviation[];
  isOwner: boolean;
  isInitialized: boolean;
  isFetching: boolean;
  isEmpty?: boolean;
  initFetch: () => void;
}

const AdoptabobblesBoughtBox: React.FC<Props> = ({
  moduleId,
  section,
  zone,
  deviations,
  isOwner,
  isInitialized,
  isFetching,
  isEmpty,
  initFetch,
}) => (
  <WidgetBox
    section={section}
    zone={zone}
    header={null}
    headerExtras={isOwner && !isEmpty && <PrivateStatus />}
    headerClassName={c(s['header'], !isOwner && s['no-header'])}
    moduleId={moduleId}
  >
    <AdoptabobblesBought
      deviations={deviations}
      isOwner={isOwner}
      isInitialized={isInitialized}
      isFetching={isFetching}
      isEmpty={isEmpty}
      initFetch={initFetch}
    />
  </WidgetBox>
);
AdoptabobblesBoughtBox.displayName = 'AdoptabobblesBoughtBox';

export default AdoptabobblesBoughtBox;
